<app-header-component
  [headerData]="currentHeaderData"
  (closeModal)="closeModal()"
></app-header-component>

<ion-content class="ion-padding-bottom">

  <form [formGroup]="guestForm" class="formCls">

    <ion-grid class="ion-padding">

      <!-- Title -->
      <ion-select
        formControlName="abbreviation"
        placeholder="Title"
        interface="popover"
        class="ion-no-padding primary-select ion-margin-bottom fs-4"
      >
        <ion-select-option value="Mr">Mr</ion-select-option>
        <ion-select-option value="Mrs">Mrs</ion-select-option>
        <ion-select-option value="Ms">Ms</ion-select-option>
      </ion-select>

      <!-- First Name -->
      <ion-input
        formControlName="firstName"
        placeholder="Enter Your First Name"
        class="primary-input ion-margin-bottom fs-4"
      ></ion-input>

      <!-- Last Name -->
      <ion-input
        formControlName="lastName"
        placeholder="Enter Your Last Name"
        class="primary-input ion-margin-bottom fs-4"
      ></ion-input>

      <!-- Email -->
      <ion-input
        formControlName="email"
        type="email"
        placeholder="Enter Your Email"
        class="primary-input ion-margin-bottom fs-4"
      ></ion-input>

      <!-- Mobile -->
      <div
        class="d-flex input-border ion-align-items-center ion-margin-bottom"
      >
        <ion-button
          (click)="selectCountryCode(selectedCountryCode)"
          class="fs-3 ion-no-margin ion-no-padding padl10 clear-btn"
        >
          {{ selectedCountryCode.flag }}
          {{ selectedCountryCode.dialCode }}
          <ion-icon
            class="fs-3 primary-icon-color"
            slot="end"
            name="chevron-down-outline"
          ></ion-icon>
        </ion-button>

        <ion-input
          formControlName="phoneNo"
          placeholder="Enter your Mobile No"
          class="primary-input mobile-input fs-4"
          type="tel"
        ></ion-input>
      </div>

      <!-- City -->
      <ion-item
        lines="none"
        [class.item-label]="!guestForm.get('city')?.value"
        (click)="selectCity()"
        class="item-border ion-margin-bottom"
      >
        <ion-label>
          {{ guestForm.get("city")?.value || "Select City*" }}
        </ion-label>
        <ion-icon name="chevron-down-outline" slot="end"></ion-icon>
      </ion-item>

      <!-- Gender -->
      <ion-select
        formControlName="gender"
        interface="popover"
        class="ion-no-padding ion-margin-bottom primary-select"
        placeholder="Gender"
      >
        <ion-select-option value="Male">Male</ion-select-option>
        <ion-select-option value="Female">Female</ion-select-option>
      </ion-select>

      <!-- DOB -->
      <ion-input
        formControlName="dob"
        type="date"
        [min]="dobValidationMin"
        [max]="dobValidationMax"
        class="primary-input ion-margin-bottom"
      >
        <div slot="label" class="fs-3 font400 date-label">
          DOB
        </div>
      </ion-input>

      <!-- DOB errors -->
      <div
        *ngIf="guestForm.hasError('invalidAdultAge')"
        class="fs-3 font500 padl10 ion-margin-vertical red-text-color"
      >
        Adults must be 12 years or older.
      </div>

      <div
        *ngIf="guestForm.hasError('invalidChildAge')"
        class="fs-3 font500 padl10 ion-margin-vertical red-text-color"
      >
        Child age must be between 2 and 12 years.
      </div>

      <div
        *ngIf="guestForm.hasError('invalidInfantAge')"
        class="fs-3 font500 padl10 ion-margin-vertical red-text-color"
      >
        Infant age must be between 0 and 2 years.
      </div>

      <!-- Type -->
      <ion-select
        formControlName="type"
        interface="popover"
        class="ion-no-padding ion-margin-bottom primary-select"
        placeholder="Type"
      >
        <ion-select-option value="adult">Adult</ion-select-option>
        <ion-select-option value="child">Child</ion-select-option>
        <ion-select-option value="infant">Infant</ion-select-option>
      </ion-select>

      <!-- Passport No -->
      <ion-input
        formControlName="passportNo"
        placeholder="Enter Your Passport No"
        class="primary-input ion-margin-bottom"
      ></ion-input>

      <div
        *ngIf="guestForm.get('passportNo')?.hasError('pattern')"
        class="fs-3 font500 padl10 ion-margin-vertical red-text-color"
      >
        Invalid Passport Number. Must be at least 6 alphanumeric characters.
      </div>

      <!-- Passport Expiry -->
      <ion-input
        formControlName="passportExpiryDate"
        type="date"
        [min]="maxDateLimit"
        class="primary-input ion-margin-bottom ion-margin-top"
      >
        <div slot="label" class="fs-3 font400 date-label">
          Passport Expiry Date
        </div>
      </ion-input>

      <div
        *ngIf="guestForm.hasError('invalidPassportDates')"
        class="fs-3 font500 padl10 ion-margin-vertical red-text-color"
      >
        Passport Expiry Date must be after the Issue Date.
      </div>

      <div
        *ngIf="guestForm.hasError('expiredPassport')"
        class="fs-3 font500 padl10 ion-margin-vertical red-text-color"
      >
        Passport has already expired.
      </div>

      <!-- Passport Issue Date -->
      <ion-input
        formControlName="passportIssueDate"
        type="date"
        [max]="maxDateLimit"
        class="primary-input ion-margin-bottom ion-margin-top"
      >
        <div slot="label" class="fs-3 font400 date-label">
          Passport Issue Date
        </div>
      </ion-input>

      <div
        *ngIf="guestForm.hasError('futureIssueDate')"
        class="fs-3 font500 padl10 ion-margin-vertical red-text-color"
      >
        Passport Issue Date cannot be in the future.
      </div>

      <!-- Passport Issue Country -->
      <ion-item
        lines="none"
        [class.item-label]="!guestForm.get('passportIssuedCountry')?.value"
        (click)="selectPassportIssuePlace()"
        class="item-border ion-margin-bottom"
      >
        <ion-label>
          {{
            guestForm.get("passportIssuedCountry")?.value ||
            "Passport Issue Place"
          }}
        </ion-label>
        <ion-icon name="chevron-down-outline" slot="end"></ion-icon>
      </ion-item>

      <!-- Country -->
      <ion-item
        lines="none"
        [class.item-label]="!guestForm.get('country')?.value"
        (click)="selectCountry()"
        class="item-border ion-margin-bottom"
      >
        <ion-label>
          {{ guestForm.get("country")?.value || "Select Country" }}
        </ion-label>
        <ion-icon name="chevron-down-outline" slot="end"></ion-icon>
      </ion-item>

      <!-- Nationality -->
      <ion-item
        lines="none"
        [class.item-label]="!guestForm.get('nationality')?.value"
        (click)="selectNationality()"
        class="item-border ion-margin-bottom"
      >
        <ion-label>
          {{ guestForm.get("nationality")?.value || "Select Nationality" }}
        </ion-label>
        <ion-icon name="chevron-down-outline" slot="end"></ion-icon>
      </ion-item>

      <!-- Address -->
      <ion-input
        formControlName="address"
        placeholder="Enter Your Address"
        class="primary-input ion-margin-bottom"
      ></ion-input>

    </ion-grid>

  </form>
</ion-content>

<ion-footer class="bg-white">
  <ion-button
    expand="block"
    class="primary-btn ion-margin fs-3 font500"
    mode="ios"
    [disabled]="guestForm.invalid"
    (click)="handleGuestDetails()"
  >
    Add
  </ion-button>
</ion-footer>
